module.exports = __webpack_public_path__ + "static/wlb-9bdef1bfc010aaa885c25bbc672b488e.png";